import { t } from '~/utils/localization';
import styles from './LockedBundleLabel.scss';
import { DivTooltip } from '@wg/wows-react-uikit';
import LockedBundleTooltip from '../Tooltip/LockedBundleTooltip';
import CountDown from '../CountDown/CountDown';
import { UserPrerequisiteCondition } from '~/types/bundle';

interface ILockedBundleLabel {
    restrictInteraction: IBundleRestrictInteraction;
    onlyTimer?: boolean;
    showTimer?: boolean;
    showCondition?: boolean;
    hideTooltip?: boolean;
}

const LockedBundleLabel = ({ restrictInteraction, showTimer, hideTooltip, showCondition, onlyTimer }: ILockedBundleLabel) => {
    const values = restrictInteraction.values as BundleRestrictInteractionDateTimeValues;
    let label = showTimer ? t('Unlocks in:') : t('Locked');

    const isToken = restrictInteraction.condition === UserPrerequisiteCondition.token;
    if (isToken) {
        label = showCondition ? restrictInteraction.values.description : t('Locked');
    }

    return (
        <DivTooltip className={styles.wrapper} tooltipBody={!hideTooltip ? <LockedBundleTooltip restrictInteraction={restrictInteraction} /> : null}>
            <div className={styles.content}>
                {(!onlyTimer || isToken) && <span>{label}</span>}
                {restrictInteraction.condition === UserPrerequisiteCondition.datetime && showTimer && (
                    <CountDown date={values.purchasableFrom} className={styles.lockedBundleTimer} withoutIcon dynamicSettings={{ maxDays: 7 }} hideSeconds />
                )}
            </div>
        </DivTooltip>
    );
};

export default LockedBundleLabel;
